import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    TextField
} from '@material-ui/core';
import { useAuthDataContext } from '../../components/auth-provider';
import { Alert } from '../../components/MySnackToast';

export const ChangeUserName = ({ className, ...rest }: any) => {

    const { user, changeUserName, isLoading, errorMessage, resetErrorMessage } = useAuthDataContext();

    const handleChange = (event: any) => {
        setNome(event.target.value);
        resetErrorMessage && resetErrorMessage();
    };

    const [nome, setNome] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (user && nome === undefined) {
            setNome(user?.name);
        }
    }, [nome, user]);

    const handleSubmit = (ev: any) => {
        ev.preventDefault();
        const { name } = ev.currentTarget.elements;
        changeUserName && changeUserName(name.value);
    }

    return (
        <form
            noValidate
            onSubmit={handleSubmit}
        >
            <Card>
                <CardHeader
                    subheader="Informações gerais"
                    title="Meus dados"
                />
                <Divider />
                <CardContent>

                    <TextField
                        fullWidth
                        label="Email"
                        margin="normal"
                        name="email"
                        value={user?.email}
                        disabled={true}
                        type="text"
                        variant="outlined"
                    />

                    <TextField
                        fullWidth
                        label="Nome"
                        margin="normal"
                        name="name"
                        value={nome}
                        onChange={handleChange}
                        type="text"
                        variant="outlined"
                    />

                </CardContent>
                <Divider />
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    p={2}
                >
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Atualizar
                    </Button>

                </Box>
                {errorMessage && <Alert severity="warning">{errorMessage}</Alert>}
            </Card>
        </form>
    );
};

